// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__n0_Zl","title":"AfterBackImages_title__3vi1a","images":"AfterBackImages_images__3eqmo"};